import { Component, input, output } from '@angular/core';
import { WeeksCounterComponent } from '@lx/quote-tool/lite/shared/ui/components';

/**
 * Duration Selector Component
 *
 * Displays a weeks counter that allows users to:
 * - Select the course duration in weeks
 * - Adjust duration within min/max constraints
 *
 * This component is presentation-only and delegates all logic to the parent.
 */
@Component({
  standalone: true,
  selector: 'lx-duration-selector',
  templateUrl: './duration-selector.component.html',
  styleUrls: ['./duration-selector.component.scss'],
  imports: [WeeksCounterComponent],
})
export class DurationSelectorComponent {
  // Inputs
  readonly minWeeks = input.required<number>();
  readonly maxWeeks = input.required<number>();
  readonly selectedDuration = input<number | undefined>(undefined);

  // Outputs
  readonly durationSelected = output<number>();

  /**
   * Handles duration changes from weeks counter
   */
  protected onSelectDuration(weeks: number): void {
    this.durationSelected.emit(weeks);
  }
}
